module.exports = __webpack_public_path__ + "static/media/post.63dab322.svg";